import React, { useState, useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useAmplitude, useTrackOnMount } from '../../providers/AmplitudeProvider';
import { AmplitudeEvent } from '../../constants/amplitudeEvents';

interface GoalSelectionProps {
    onSelect: (goal: string) => void;
    onBack: () => void;
}

const GoalSelection: React.FC<GoalSelectionProps> = ({ onSelect, onBack }) => {
    const [selectedOption, setSelectedOption] = useState<string | null>(null);
    const { trackEvent } = useAmplitude();

    useTrackOnMount([
        { event: AmplitudeEvent.QUESTION_VIEWED, properties: { step_number: 5, screen_name: 'primary_goal' } },
    ]);

    const handleSelect = (optionId: string) => {
        setSelectedOption(optionId);
        trackEvent(AmplitudeEvent.QUESTION_ANSWERED, {
            step_number: 5,
            screen_name: 'primary_goal',
            main_goal: optionId,
        });
        setTimeout(() => {
            onSelect(optionId);
        }, 500);
    };
    return (
        <div className="min-h-screen bg-white flex flex-col">
            <header className="py-[26px] px-4 bg-white border-b border-[#17171714]">
                <button
                    onClick={onBack}
                    className="absolute left-4 top-[26px] w-10 h-10 flex items-center justify-center rounded-full border border-[#00000066]"
                >
                    <ArrowLeft className="w-5 h-5" />
                </button>
                <div className="flex justify-center">
                    <div className="flex flex-col items-center gap-2">
                        <span className="text-[18px] text-[#0B0B0B] font-semibold">
                            My Profile
                        </span>
                        <div className="flex gap-2">
                            <div className="flex-1 w-9 h-[4px] rounded-full bg-[#369FFF]" />
                            <div className="flex-1 w-9 h-[4px] rounded-full bg-[#E5E5EA]" />
                            <div className="flex-1 w-9 h-[4px] rounded-full bg-[#E5E5EA]" />
                            <div className="flex-1 w-9 h-[4px] rounded-full bg-[#E5E5EA]" />
                            <div className="flex-1 w-9 h-[4px] rounded-full bg-[#E5E5EA]" />
                        </div>
                    </div>
                </div>
            </header>

            <div className="flex-1 flex flex-col px-6 pt-[60px]">
                <div className="max-w-lg mx-auto w-full">
                    <h1 className="font-poppins text-[26px]/[43px] font-semibold text-center mb-12">
                        What's your main goal?
                    </h1>

                    <div className="space-y-4">
                        {[
                            { id: 'lose_weight', label: 'Lose weight' },
                            { id: 'maintain_weight', label: 'Maintain weight and get fit' },
                        ].map((option) => {
                            const isSelected = selectedOption === option.id;
                            return (
                                <button
                                    key={option.id}
                                    onClick={() => handleSelect(option.id)}
                                    className={`w-full px-6 py-5 border rounded-[12px] flex items-center justify-between transition-colors ${isSelected ? 'border-[#369FFF]' : 'border-[#00000014] hover:border-[#369FFF]'}`}
                                >
                                    <span className="text-[16px] font-medium">{option.label}</span>
                                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-[#369FFF]' : 'border-[#D1D5DB]'}`}>
                                        {isSelected && (
                                            <div className="w-3.5 h-3.5 rounded-full bg-[#369FFF]" />
                                        )}
                                    </div>
                                </button>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GoalSelection;
